// ============================================
// Seed Templates: Clinical
// Category: clinical
// Templates: 5
// ============================================

import type { DocTemplate } from '../../types/docops';

export const SEED_TEMPLATES_CLINICAL: DocTemplate[] = [
  // ── 12.1 Clinical Protocols & Decision Trees ──
  {
    id: '12.1-clinical-protocols',
    categoryId: 'clinical',
    track: 'operational',
    title: 'Clinical Protocols & Decision Trees',
    description:
      'Clinical decision trees for supplement protocols, tier assessment, and escalation criteria.',
    templateContent: '',
    requiredVariables: ['brandName', 'medicalDirectorName'],
    generationPrompt:
      'Already built. Biomarker ranges in src/data/biomarkerRanges.ts (44 markers, 9 categories). Protocol builder AI skill generates protocols based on lab results.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 1,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 12.2 Supplement Formulary ──
  {
    id: '12.2-supplement-formulary',
    categoryId: 'clinical',
    track: 'operational',
    title: 'Supplement Formulary',
    description:
      'Complete product formulary with dosages, triggers, contraindications, and evidence levels.',
    templateContent: '',
    requiredVariables: ['brandName', 'medicalDirectorName'],
    generationPrompt:
      'Already built. Formulary managed via /admin (products, bundles, safety rules). 29+ supplement products, 25 bundles, safety rules with interaction checking.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 2,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 12.3 Clinical Escalation Criteria ──
  {
    id: '12.3-escalation-criteria',
    categoryId: 'clinical',
    track: 'operational',
    title: 'Clinical Escalation Criteria',
    description:
      '4-tier clinical escalation framework with criteria for tier advancement and provider referral.',
    templateContent: '',
    requiredVariables: ['brandName', 'medicalDirectorName'],
    generationPrompt:
      'Already built. 4-tier system (Tier 1: optimization, Tier 2: clinical support, Tier 3: specialist referral, Tier 4: urgent care). Implemented in protocol builder.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 3,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 12.4 Biomarker Reference Guide ──
  {
    id: '12.4-biomarker-reference',
    categoryId: 'clinical',
    track: 'operational',
    title: 'Biomarker Reference Guide',
    description:
      'Standard and functional ranges for all 44 tracked biomarkers across 9 categories.',
    templateContent: '',
    requiredVariables: ['brandName'],
    generationPrompt:
      'Already built. Complete reference in src/data/biomarkerRanges.ts. Categories: metabolic, hormonal, inflammatory, nutritional, hematologic, lipid, thyroid, hepatic, renal.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 0,
    sortOrder: 4,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },

  // ── 12.5 AI Chat Skill Architecture ──
  {
    id: '12.5-ai-chat-skill-plan',
    categoryId: 'clinical',
    track: 'operational',
    title: 'AI Chat Skill Architecture',
    description:
      'Architecture plan for the 5 AI skills: Intake Nurse, Lab Analyst, Protocol Builder, Med Reasoning, Client Enrichment.',
    templateContent: '',
    requiredVariables: ['brandName'],
    generationPrompt:
      'Generate AI Chat Skill Architecture document for {{brandName}}. 5 skills: 1) Intake Nurse (Gemini Flash — collects health profile, identifies archetype, age/sex/goals), 2) Lab Analyst (Claude Sonnet — parses lab PDFs, extracts biomarkers, generates LabReport), 3) Protocol Builder (Claude Sonnet — maps biomarkers to supplements, generates Protocol with timing/dosage), 4) Med Reasoning (Claude Sonnet — clinical tier assessment, risk flags, escalation factors), 5) Client Enrichment (Gemini Flash — conversational follow-up, goal refinement, education). For each: input/output types, prompt structure, token budget, fallback behavior, mock mode behavior. Format: technical architecture document.',
    attorneyReviewRequired: false,
    launchBlocker: false,
    estimatedPages: 5,
    sortOrder: 5,
    generationRound: 6,
    dependencies: [],
    anchorSections: [],
    inheritedProvisions: [],
  },
];
